import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
//import { DataGrid, Column, Editing, Button, Popup, Form, Item, SearchPanel, Grouping } from 'devextreme-react/data-grid'
//import { TreeList, RequiredRule, Lookup, Selection, RowDragging, Scrolling, ColumnFixing, Paging, Pager } from 'devextreme-react/tree-list'
import {
  Chart,
  Series,
  CommonSeriesSettings,
  Legend,
  ValueAxis,
  ArgumentAxis,
  Title,
  Export,
  Tooltip,
  Format,
} from "devextreme-react/chart";
import { Popup } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import PieChart, { Label, Connector, Size } from "devextreme-react/pie-chart";
import useSWR from "swr";

import Input from "../../Components/Input";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import ErrorRange from "../../Components/ErrorRange";
import { checkRoles } from "../../Utils/helper";
import ActionNotifications from "../../Components/ActionNotifications";
import Select from "../../Components/Select";
import "./styles.css";

export default function ProjectsReportPage() {
  const DropdownArrowIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
    >
      <path d="M5 5L0 0H10L5 5Z" fill="white" fillOpacity="0.7" />
    </svg>
  );

  const [state, setState] = useState({
      projectCatOptions: [
        { label: "All", value: "All" },
        { label: "Federal", value: "Federal" },
        { label: "Industry", value: "Industry" },
        { label: "Overhead", value: "Overhead" },
      ],
      viewOptions: [
        { label: "Open", value: "Open" },
        { label: "Past Due", value: "Past Due" },
      ],
      showSpinner: false,
      notifications: [],
      popup: false,
      totalWO: [],
      tasks: [],
      projectTasks: [],
      projects: [],
      openWorkPlanReport: [],
      pastDuePlanReport: [],
      billingCode: "",
      view: "Open",
      category: "All",
    }),
    { data, mutate, error } = useSWR(
      `${apiBaseURL}/api/Reports/Projects?type=${state.category}`
    ),
    { data: projData, error: projError } = useSWR(
      checkRoles(5)
        ? `${apiBaseURL}/api/project/Supervisor/Current`
        : `${apiBaseURL}/api/project/User/Current`
    ),
    { data: taskData, error: taskError } = useSWR(
      `${apiBaseURL}/api/Reports/TaskIdentification?billingCode=3.7`
    );
  //{ data: taskData, error: taskError } = useSWR(`${apiBaseURL}/api/Reports/TaskIdentification?billingCode=${state.billingCode}`);

  const onInputChange = async (e) => {
    console.log(e);
    const { name, value } = e.target,
      inputNameError = `${name}Error`;
    let stateValues = { ...state };
    stateValues = { ...stateValues, [name]: value };

    if (name !== "") {
      stateValues = { ...stateValues, [inputNameError]: false };
    }

    setState(stateValues);
    mutate();
  };
  console.log(data);
  console.log(projData);

  useEffect(() => {
    if (data && projData && taskData && projData.data) {
      setState({
        ...state,
        tasks: taskData.data,
        projectTasks: projData.data.map((x) => ({
          label: `${x.billingCode} - ${x.taskName}`,
          value: x.id,
        })),
        totalWO: data.data.map((x) => x.openWOs),
        projects: data.data.map((x) => ({
          name: x.name,
          //type: x.type,
          allWOs: x.allWOs,
          openWOs: x.openWOs,
          pastDueWOs: x.pastDueWOs,
          openWorkPlanReport: x.openWorkPlanReport,
          pastDuePlanReport: x.pastDuePlanReport,
        })),
        openWorkPlanReport: data.data.map((x) => ({
          id: x.id,
          name: x.name,
          taskId: x.openWorkPlanReport.map((x) => x.id),
          billingCode: x.openWorkPlanReport.map((x) => x.billingCode),
          startDate: x.openWorkPlanReport.map((x) => x.startDate),
          endDate: x.openWorkPlanReport.map((x) => x.endDate),
          actualEndDate: x.openWorkPlanReport.map((x) => x.actualEndDate),
        })),
        pastDuePlanReport: data.data.map((x) => ({
          id: x.id,
          name: x.name,
          taskId: x.pastDuePlanReport.map((x) => x.id),
          billingCode: x.pastDuePlanReport.map((x) => x.billingCode),
          startDate: x.pastDuePlanReport.map((x) => x.startDate),
          endDate: x.pastDuePlanReport.map((x) => x.endDate),
          actualEndDate: x.pastDuePlanReport.map((x) => x.actualEndDate),
        })),
      });
    }
  }, [data, projData, taskData]);

  const onPointClick = (e) => {
    console.log(e);
    const proj = state.projects.find((x) => x.name === e.target.argument);
    console.log(proj);
    return (
      <>
        <Popup
          visible={true}
          onHiding={() => setState({ ...state, popup: false })}
          hideOnOutsideClick={true}
          title="More Info"
          width={500}
          height={250}
          resizeEnabled={true}
        >
          <ScrollView height="100%" width="100%">
            <ul>
              {state.view === "Open"
                ? proj.openWorkPlanReport.map((x) => (
                    <li key={x.id}>{x.billingCode}</li>
                  ))
                : proj.pastDuePlanReport.map((x) => (
                    <li key={x.id}>{x.billingCode}</li>
                  ))}
            </ul>
          </ScrollView>
        </Popup>
      </>
    );
  };

  const renderResults = () => {
    const customizeTooltip = (e) => {
      console.log(e);
      const open = e.point.data.openWorkPlanReport;
      const past = e.point.data.pastDuePlanReport;
      if (e.seriesName !== "Total") {
        console.log(open);

        return (
          <ul>
            {open.map((x) => (
              <li key={x.id}>{x.billingCode}</li>
            ))}
          </ul>
        );
      }
    };

    if (
      data &&
      data.statusCode &&
      projData &&
      projData.statusCode &&
      taskData &&
      taskData.statusCode
    ) {
      if (data.data.length > 0) {
        const allowedPageSizes = [25, 50, 100];

        return (
          <div className="row">
            <div className="row">
              <div className="row">
                <h3 className="text-center mb-5 white">
                  {state.category} Projects Report
                </h3>
              </div>
              <div className="row g-0">
                <Chart
                  id="chart"
                  dataSource={state.projects}
                  onPointClick={
                    (() => setState({ ...state, popup: true }), onPointClick)
                  }
                >
                  <CommonSeriesSettings
                    argumentField="name"
                    type="stackedBar"
                  />
                  {state.view === "Open" ? (
                    <Series valueField="openWOs" name="Open" color="#8bce55" />
                  ) : (
                    <Series
                      valueField="pastDueWOs"
                      name="Past Due"
                      color="#e05d5d"
                    />
                  )}
                  <Series valueField="allWOs" name="Total" color="#5ea6eb" />
                  <ArgumentAxis
                    label={{
                      font: { color: "white" },
                    }}
                    color="white"
                    // grid={{ color: "white" }}
                  />
                  <ValueAxis
                    position="left"
                    axisDivisionFactor="50"
                    color="white"
                    label={{
                      font: { color: "white" },
                    }}
                  >
                    <Title text="# of Work Orders" />
                  </ValueAxis>
                  <Legend
                    verticalAlignment="bottom"
                    horizontalAlignment="center"
                    itemTextPosition="right"
                    font={{ color: "white" }}
                  />
                  {/* <Export enabled={true} />*/}
                  <Tooltip
                    enabled={true}
                    location="edge"
                    customizeTooltip={customizeTooltip}
                    font={{ color: "white" }}
                  />
                </Chart>
              </div>
              {/* <div className="contentBox filler"><h3>{state.view} Tasks</h3></div>
                            <div>
                                 <DataGrid
                                    dataSource={state.projects}
                                    rowAlternationEnabled={true}
                                    showBorders={true}>
                                    <Grouping autoExpandAll={false} />

                                    <Column dataField="id" visible={false} />
                                    <Column dataField="name" caption="Project" width={100} groupIndex={0} />
                                    <Column dataField="openWorkPlanReport.billingCode" minWidth={200} />
                                    <Column dataField="openWorkPlanReport.startDate" minWidth={200} />
                                    <Column dataField="openWorkPlanReport.endDate" minWidth={200} />
                                </DataGrid>
                                <TreeList
                                    id="treelist"     //??
                                    className="contentBox"
                                    dataSource={state.projects}
                                    showRowLines={true}
                                    showColumnLines={true}
                                    showBorders={true}
                                    wordWrapEnabled={true}
                                    itemsExpr={state.view === 'Open' ? "openWorkPlanReport" : "pastDuePlanReport"}
                                    dataStructure="tree"
                                    rowAlternationEnabled={true}
                                >
                                    <Scrolling
                                        mode="standard" />
                                    <Paging
                                        enabled={true}
                                        defaultPageSize={10} />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={allowedPageSizes}
                                        showInfo={true} />
                                    <Column
                                        dataField="name"
                                        minWidth={200}>
                                    </Column>
                                    <Column
                                        dataField="billingCode"
                                        minWidth={200}>
                                    </Column>
                                    <Column
                                        dataField="startDate"
                                        dataType="date"
                                        minWidth={110}>
                                    </Column>
                                    <Column
                                        dataField="endDate"
                                        dataType="date"
                                        minWidth={110}>
                                    </Column>
                                </TreeList>
                            </div>*/}
              {/*<div className="row">
                                <div className="col">
                                    <Select
                                        arrayOfOptions={state.projectTasks}
                                        name="projectTasks"
                                        onChange={onInputChange}
                                        selected={state.billingCode}
                                        labelTitle="Billing Code"
                                        placeholderOption
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div>
                                    <PieChart
                                        id="pie"
                                        dataSource={state.tasks}
                                        palette="Bright"
                                        title="On-Time Performance"
                                      >
                                        <Series
                                          argumentField="performance"
                                          valueField="area"
                                        >
                                          <Label visible={true}>
                                            <Connector visible={true} width={1} />
                                          </Label>
                                        </Series>

                                        <Size width={500} />
                                    </PieChart>
                                </div>
                                <div>
                                    <Chart id="chart"
                                        title="Planned vs Actual Hours per task"
                                        dataSource={state.tasks}
                                    >
                                        <CommonSeriesSettings
                                            argumentField="task"
                                            type="bar"
                                            hoverMode="allArgumentPoints"
                                            selectionMode="allArgumentPoints"
                                        >
                                            <Label visible={true}>
                                                <Format type="fixedPoint" precision={0} />
                                            </Label>
                                        </CommonSeriesSettings>
                                        <Series
                                            valueField="planned"
                                            name="Planned"
                                        />
                                        <Series
                                            valueField="actual"
                                            name="Actual"
                                        />
                                        <Legend verticalAlignment="bottom" horizontalAlignment="center"></Legend>
                                    </Chart>
                                </div>
                            </div>*/}
            </div>
          </div>
        );
      }
      return (
        <h5 className="text-center mb-0">
          There are no projects to generate a project report. Try again by
          selecting a different category.
        </h5>
      );
    } else if (
      data &&
      !data.statusCode &&
      projData &&
      !projData.statusCode &&
      taskData &&
      !taskData.statusCode
    ) {
      return (
        <>
          <h3 className="red">
            <u>Error{data.messeges.length > 1 && "s"}</u>
          </h3>
          <ul class="mb-0" style={{ listStyleType: "circle" }}>
            {data.messeges.map((msg) => {
              return (
                <li className="red">
                  <h5 className="mb-0">{msg}</h5>
                </li>
              );
            })}
          </ul>
        </>
      );
    } else if (
      !data &&
      !projData &&
      !taskData &&
      !error &&
      !projError &&
      !taskError
    ) {
      return (
        <div className="col text-center">
          <FontAwesomeIcon icon={faSpinner} className="fa-spin" size="5x" />
        </div>
      );
    }
  };

  return (
    <div className="px-lg-4 content">
      <ActionNotifications arrayOfToasts={state.notifications} />
      <div className="px-3 page-content">
        <div className="container-fluid g-0">
          <div className="row g-3">
            <div className="col">
              <div className="contentBox p-5 mb-3">
                <div className="row">
                  <h1 className="white">Projects Report</h1>
                </div>
                <div className="row">
                  <div className="col-6">
                    <Select
                      arrayOfOptions={state.projectCatOptions}
                      name="category"
                      onChange={onInputChange}
                      selected={state.category}
                      labelTitle="Category"
                      placeholderOption
                      iconComponent={<DropdownArrowIcon />}
                    />
                  </div>
                  <div className="col-6">
                    <Select
                      arrayOfOptions={state.viewOptions}
                      name="view"
                      onChange={onInputChange}
                      selected={state.view}
                      labelTitle="View"
                      placeholderOption
                      iconComponent={<DropdownArrowIcon />}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pb-5">
            <div className="col-12">
              <div className="contentBox p-5">
                {!error && !projError && !taskError ? (
                  renderResults()
                ) : (
                  <ErrorRange />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
